// TabComponent.jsx

import React, { useState } from "react";
import Card from "./Card";
import AccordionBlock from "../components/AccordionBlock";
import useMediaQuery from "../utility/useMediaQuery";
import Carousel from "./ui/Carousel";

const TabComponent = ({ tabData, carouselOnMobile = false }) => {
  const [activeTab, setActiveTab] = useState(tabData[0].label);
  const isMobile = useMediaQuery("(max-width: 767px)");

  const openWhatsAppChat = () => {
    window.open("https://wa.me/919884702223", "_blank", "noopener,noreferrer");
  };

  const handleTabClick = (tabLabel) => {
    setActiveTab(tabLabel);
  };

  return (
    <div>
      {carouselOnMobile && isMobile ? (
        <Carousel itemClassName="w-1/3" gap="gap-2" showArrows={false}>
          {tabData.map((tab) => {
            const isActive = activeTab === tab.label;
            return (
              <button
                key={tab.label}
                type="button"
                onClick={() => handleTabClick(tab.label)}
                className={
                  "w-full rounded-xl px-4 py-2 text-sm font-semibold transition " +
                  (isActive
                    ? "bg-slate-900 text-white"
                    : "bg-white text-slate-700 border border-slate-200 hover:bg-slate-100")
                }
              >
                {tab.label}
              </button>
            );
          })}
        </Carousel>
      ) : (
        <div className="flex flex-wrap gap-2 rounded-2xl border border-slate-200 bg-slate-50 p-2">
          {tabData.map((tab) => {
            const isActive = activeTab === tab.label;
            return (
              <button
                key={tab.label}
                type="button"
                onClick={() => handleTabClick(tab.label)}
                className={
                  "rounded-xl px-4 py-2 text-sm font-semibold transition " +
                  (isActive
                    ? "bg-slate-900 text-white"
                    : "bg-white text-slate-700 border border-slate-200 hover:bg-slate-100")
                }
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      )}

      <div className="mt-4">
        {tabData.map((tab) => (
          <div
            key={tab.label}
            style={{ display: activeTab === tab.label ? "block" : "none" }}
          >
            {tab.label === "Q&A" ? (
              <div className="rounded-2xl border border-slate-200 bg-white p-4 md:p-6">
                <AccordionBlock faqList={tab.description ? tab.description : []} />
              </div>
            ) : (
              carouselOnMobile && isMobile ? (
                <Carousel showDots>
                  {tab.submenu.map((item) => (
                    <button
                      key={item.label}
                      type="button"
                      onClick={openWhatsAppChat}
                      aria-label={`Open WhatsApp chat for ${item.label}`}
                      className="block w-full text-left"
                    >
                      <Card
                        title={item.label}
                        imageURL={item.imageURL}
                        description={item.description}
                      />
                    </button>
                  ))}
                </Carousel>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {tab.submenu.map((item) => (
                    <button
                      key={item.label}
                      type="button"
                      onClick={openWhatsAppChat}
                      aria-label={`Open WhatsApp chat for ${item.label}`}
                      className="block w-full text-left"
                    >
                      <Card
                        title={item.label}
                        imageURL={item.imageURL}
                        description={item.description}
                      />
                    </button>
                  ))}
                </div>
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabComponent;
